module.exports = "<p>\n  viewuser works!\n</p>\n"